interface handleMapOpenProps {
  latitude: number;
  longitude: number;
}

export default function handleMapOpen({
  latitude,
  longitude,
}: handleMapOpenProps) {
  window.open(
    `https://www.google.com/maps?q=${latitude},${longitude}`,
    '_blank'
  );
}
